module.exports = __webpack_public_path__ + "img/Meta.f8b75c50.png";